module.exports = __webpack_public_path__ + "img/mdxg.5fc856a5.png";